<!-- How chubb protect your business Section -->
<div class="container section">
  <h2 class="section-title">{{ protectTitle }}</h2>
  @if (productDesc) {
    <p class="section-description">{{ productDesc }}</p>
  }
</div>

<div class="container">
  <div class="product-info">
    @for (item of protectArrItems; track item) {
      <div class="product-info-section protect-sections">
        <img class="protect-sections-tileimg" src="{{ imageBasePath+item?.iconURL }}" alt="icon"/>
        <h4 class="protect-sections-title" [ngClass]="{'minHeigth-title':isBopPage}">{{ item.title }}</h4>
        @if (item.text) {
          <div>
            <p class="protect-sections-text" [ngClass]="{'minHeigth-text':isBopPage}">{{ item.text }}</p>
          </div>
        }
        @if (item.infoItems) {
          <div>
            @for (info of item.infoItems; track info) {
              <ul class="protect-sections-info">
                <li class="protect-sections-info-items">{{ info?.text }}</li>
              </ul>
            }
          </div>
        }
        @if (item?.buttonName) {
          <button
            class="btn"
            (click)="navigateRoutes(item.buttonURL)"
            >
            {{item?.buttonName}}
          </button>
        }
      </div>
    }
  </div>
</div>
